import { render, staticRenderFns } from "./PublicLink.vue?vue&type=template&id=143a63a8&scoped=true&"
import script from "./PublicLink.vue?vue&type=script&lang=ts&"
export * from "./PublicLink.vue?vue&type=script&lang=ts&"
import style0 from "./PublicLink.vue?vue&type=style&index=0&id=143a63a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a63a8",
  null
  
)

export default component.exports